import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import "firebase/analytics";

// karma mock
let firebaseExport = firebase;
if (window.firebase) {
    firebaseExport = window.firebase;
}

export default firebaseExport;
